import { Reveal } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/services";

export function FAQ() {
  return (
    <section data-testid="faq-section" className="py-20 sm:py-28 bg-brand-mist">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="label-eyebrow">FAQ</p>
          <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-medium tracking-tight text-brand-navy text-balance">
            Frequently asked questions
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-10">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-xl border border-border bg-white px-5 border-b"
              >
                <AccordionTrigger className="font-heading font-semibold text-brand-navy hover:no-underline text-left text-base">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed text-[15px]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
